<template>
	<div class="bill">
		<div class="left">
			<div class="top">
				<div class="title">
					<div class="name">
						<div class="padding"></div>
						收入情况
					</div>
					<div class="filter">
						<el-select v-model="value1" placeholder="请选择" size="mini" @change="firstChange">
							<el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id" ></el-option>
						</el-select>
					</div>
				</div>
				<div class="total">
					<div class="value">¥{{ total }}</div>
					<div class="key">总收入</div>
				</div>
			</div>
			<div class="table" style="min-height: 400px;">
				<el-table :data="list">
					<el-table-column label="序号" align="center" width="100" type="index"></el-table-column>
					<el-table-column label="事件" width="200" align="center">已完成订单</el-table-column>
					<el-table-column label="时间" align="center" prop="addTime"></el-table-column>
					<el-table-column label="金额" align="center" prop="price"></el-table-column>
				</el-table>
			</div>
		</div>
		<div class="right">
			<div class="title">
				<div class="name">
					<div class="padding"></div>
					工单数量统计（个）
				</div>
				<div class="filter">
					<el-select v-model="value2" placeholder="请选择" size="mini" @change="secChange">
						<el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id" ></el-option>
					</el-select>
				</div>
			</div>
			<ul>
				<li>
					<div class="cont">
						<div class="value">{{ totalOrder }}</div>
						<div class="key">全部订单</div>
					</div>
					<div class="type">
						<div class="line">
							<span>进行中</span>
							{{ underway }}
						</div>
						<div class="line">
							<span>已完成</span>
							{{ finish }}
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import {staFirstApi,staSecApi,staThApi} from '../../http/electrician/api.js'
export default {
	name: 'bill',
	data() {
		return {
			options: [
				{
					label: '7天',
					id: 7
				},
				{
					label: '15天',
					id: 15
				},
				{
					label: '30天',
					id: 30
				},
				{
					label: '90天',
					id: 90
				}
			],
			value1: 7,
			value2: 7,
			totalOrder: 0,
			underway: 0,
			finish: 0,
			total: 0,
			list: []
		};
	},
	created() {
		this.getFirst()
		this.getSec()
		this.getTh()
	},
	methods: {
		getFirst(){
			staFirstApi({
				day: this.value1
			}).then(res => {
				this.total = res.count
			})
		},
		getSec(){
			staSecApi({
				day: this.value1
			}).then(res => {
				this.totalOrder = res.zong
				this.underway = res.jxz
				this.finish = res.ywc
			})
		},
		getTh(){
			staThApi({
				day: 30
			}).then(res => {
				this.list = res
			})
		},
		firstChange(val){
			this.value1 = val
			this.getFirst()
		},
		secChange(){
			this.value2 = val
			this.getSec()()
		}
	},
};
</script>

<style lang="less" scoped="scoped">
.bill {
	width: 100%;
	display: flex;
	justify-content: space-between;
	.title {
		width: 100%;
		height: 50px;
		border-bottom: 1px solid @vue-border-color;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 0px @vue-spacing-row-base;
		.name {
			height: 100%;
			display: flex;
			align-items: center;
		}
		.padding {
			width: 4px;
			height: 14px;
			background: #ff5252;
			margin-right: @vue-spacing-row-sm;
		}
	}
	.left,
	.right {
		width: 49%;
	}
	.left {
		.top,
		.table {
			width: 100%;
			background: @vue-bg-color;
		}
		.top {
			.total {
				width: 100%;
				height: 140px;
				display: flex;
				align-items: center;
				align-content: center;
				flex-wrap: wrap;
				.value,
				.key {
					width: 100%;
					height: 40px;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				.value {
					font-size: @vue-font-size-lg;
					font-weight: bold;
				}
				.key {
					color: @vue-text-color-grey;
				}
			}
		}
		.table {
			margin-top: @vue-spacing-col-lg;
			ul {
				width: 100%;
				border-top: 1px solid @vue-border-color;
				li {
					width: 100%;
					height: 70px;
					display: flex;
					justify-content: space-between;
					border-bottom: 1px solid @vue-border-color;
					font-size: @vue-font-size-sm - 2;
					.list-line-tab {
						width: 33.3%;
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
					}
				}
				.list-head {
					height: 50px;
					.list-line-tab {
						font-size: @vue-font-size-sm - 2;
						color: @vue-text-color-grey;
					}
				}
				li:last-child {
					border: none;
				}
			}
		}
	}
	.right {
		background: @vue-bg-color;
		height: 190px;
		ul {
			width: 100%;
			height: calc(100% - 50px);
			display: flex;
			justify-content: space-between;
			align-items: center;
			li {
				width: 100%;
				border-right: 1px solid @vue-border-color;
				box-sizing: border-box;
				display: flex;
				.cont,
				.type {
					width: 50%;
				}
				.cont {
					border-right: 1px solid @vue-border-color;
					box-sizing: border-box;
					.value,
					.key {
						width: 100%;
						height: 30px;
						display: flex;
						justify-content: center;
						align-items: center;
					}
					.value {
						font-size: @vue-font-size-sm + 2;
						font-weight: bold;
					}
					.key {
						color: @vue-text-color-grey;
						font-size: @vue-font-size-sm - 2;
					}
				}
				.type {
					.line {
						width: 100%;
						height: 30px;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: @vue-font-size-sm - 2;
						span {
							color: @vue-text-color-grey;
							margin-right: @vue-spacing-row-sm;
						}
					}
				}
			}
		}
	}
}
</style>
